import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem("sg_admin_token"));
    const [admin, setAdmin] = useState(() => {
        try {
            const stored = localStorage.getItem("sg_admin_user");
            return stored ? JSON.parse(stored) : null;
        } catch {
            return null;
        }
    });

    const login = (tokenValue, user) => {
        setToken(tokenValue);
        setAdmin(user);
        localStorage.setItem("sg_admin_token", tokenValue);
        localStorage.setItem("sg_admin_user", JSON.stringify(user));
    };

    const logout = () => {
        setToken(null);
        setAdmin(null);
        localStorage.removeItem("sg_admin_token");
        localStorage.removeItem("sg_admin_user");
    };

    return (
        <AuthContext.Provider value={{ token, admin, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
};
